module.exports = __webpack_public_path__ + "KDMarenice.jpg?36a28aab26796c3f43b206bfcd2df4c9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/KDMarenice.jpg
// module id = 249
// module chunks = 0